import React from "react";
import PropTypes from "prop-types";

import { Checkbox } from "widgets/inputs";

import styles from "./rowheader.css";

export function RowHeader(props) {
  const { label, canSelect = true, checked = false, onChange } = props;
  return (
    <div
      className={`${styles.selectall} ${label ? styles.labelled : ""} ${
        canSelect ? styles.canselect : ""
      } ${checked ? styles.checked : ""}`}
    >
      {canSelect && (
        <Checkbox
          className={styles.checkbox}
          value={checked}
          onClick={onChange}
        />
      )}
      {label && <span className={styles.label}>{label}</span>}
    </div>
  );
}

RowHeader.propTypes = {
  label: PropTypes.string,
  canSelect: PropTypes.bool,
  checked: PropTypes.bool,
  onChange: PropTypes.bool
};
